import { api as generatedApi } from './api-generated';

export const api = generatedApi.enhanceEndpoints({
  addTagTypes: [
    'Departments',
    'CompanyPage',
    'Companies',
    'InventoryHardware',
    'InventoryParts',
    'Hardware',
    'RMA',
    'RepairComments',
    'InventoryPartsUsed',
    'Signups',
    'Users',
    'Demos',
    'SoftwareVersions',
    'SoftwareLinks',
    'AnalyzerTypeLinks',
    'Firmware',
    'Utilities',
    'AnalyzerTypes',
    'Software',
    'OperatingSystem',
    'SupportPurchase',
    'Orders',
    'Modules',
    'Licenses',
    'HardwareCategories',
    'SystemModuleLicenses',
  ],
  endpoints: {
    findAllCompanies: {
      providesTags: () => [{ type: 'Companies', id: 'LIST' }],
    },
    createCompany: {
      invalidatesTags: [{ type: 'Companies', id: 'LIST' }],
    },
    findOneCompany: {
      providesTags: (result, error, { id }) => [
        { type: 'Companies', id },
        { type: 'CompanyPage', id: 'PAGE' },
      ],
    },
    updateCompany: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Companies', id },
        { type: 'Companies', id: 'LIST' },
        { type: 'Departments', id: 'LIST' },
      ],
    },
    deleteCompany: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Companies', id },
        { type: 'Companies', id: 'LIST' },
        { type: 'Departments', id: 'LIST' },
      ],
    },
    findAlldepartments: {
      providesTags: () => [{ type: 'Departments', id: 'LIST' }],
    },
    createDepartment: {
      invalidatesTags: [
        { type: 'Departments', id: 'LIST' },
        { type: 'Companies', id: 'LIST' },
        { type: 'SupportPurchase', id: 'LIST' },
        { type: 'Hardware', id: 'LIST' },
        { type: 'Orders', id: 'LIST' },
        { type: 'CompanyPage', id: 'PAGE' },
      ],
    },
    findOneDepartment: {
      providesTags: (result, error, { id }) => [{ type: 'Departments', id }],
    },
    updateDepartment: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Departments', id },
        { type: 'Departments', id: 'LIST' },
        { type: 'Hardware', id: 'LIST' },
        { type: 'Companies', id: 'LIST' },
        { type: 'SupportPurchase', id: 'LIST' },
        { type: 'Orders', id: 'LIST' },
        { type: 'CompanyPage', id: 'PAGE' },
      ],
    },
    deleteDepartment: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Departments', id },
        { type: 'Departments', id: 'LIST' },
        { type: 'Hardware', id: 'LIST' },
        { type: 'Companies', id: 'LIST' },
        { type: 'SupportPurchase', id: 'LIST' },
        { type: 'Orders', id: 'LIST' },
        { type: 'CompanyPage', id: 'PAGE' },
      ],
    },
    findAllInventoryParts: {
      providesTags: () => [{ type: 'InventoryParts', id: 'LIST' }],
    },
    createInventoryPart: {
      invalidatesTags: [{ type: 'InventoryParts', id: 'LIST' }],
    },
    findOneInventoryPart: {
      providesTags: (result, error, { id }) => [{ type: 'InventoryParts', id }],
    },
    updateInventoryPart: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'InventoryParts', id },
        { type: 'InventoryParts', id: 'LIST' },
      ],
    },
    removeInventoryPart: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'InventoryParts', id },
        { type: 'InventoryParts', id: 'LIST' },
      ],
    },
    findAllInventoryHardware: {
      providesTags: () => [{ type: 'InventoryHardware', id: 'LIST' }],
    },
    createInventoryHardware: {
      invalidatesTags: [{ type: 'InventoryHardware', id: 'LIST' }],
    },
    findOneInventoryHardware: {
      providesTags: (result, error, { id }) => [
        { type: 'InventoryHardware', id },
      ],
    },
    updateInventoryHardware: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'InventoryHardware', id },
        { type: 'InventoryHardware', id: 'LIST' },
      ],
    },
    removeInventoryHardware: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'InventoryHardware', id },
        { type: 'InventoryHardware', id: 'LIST' },
      ],
    },
    findAllHardware: {
      providesTags: () => [{ type: 'Hardware', id: 'LIST' }],
    },
    findAllHardwareForUser: {
      providesTags: () => [{ type: 'Hardware', id: 'LIST' }],
    },
    findAllDepartmentsForUser: {
      providesTags: () => [{ type: 'Departments', id: 'LIST' }],
    },
    createHardware: {
      invalidatesTags: [{ type: 'Hardware', id: 'LIST' }],
    },
    findOneHardware: {
      providesTags: (result, error, { id }) => [{ type: 'Hardware', id }],
    },
    updateHardware: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Hardware', id },
        { type: 'Hardware', id: 'LIST' },
      ],
    },
    removeHardware: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Hardware', id },
        { type: 'Hardware', id: 'LIST' },
      ],
    },
    findAllDemos: {
      providesTags: () => [{ type: 'Demos', id: 'LIST' }],
    },
    createDemo: {
      invalidatesTags: [
        { type: 'Demos', id: 'LIST' },
        { type: 'InventoryHardware', id: 'LIST' },
      ],
    },
    findOneDemos: {
      providesTags: (result, error, { id }) => [{ type: 'Demos', id }],
    },
    updateDemo: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Demos', id },
        { type: 'Demos', id: 'LIST' },
        { type: 'InventoryHardware', id: 'LIST' },
      ],
    },
    removeDemo: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Demos', id },
        { type: 'Demos', id: 'LIST' },
        { type: 'InventoryHardware', id: 'LIST' },
      ],
    },
    findAllRmas: {
      providesTags: () => [{ type: 'RMA', id: 'LIST' }],
    },
    createRma: {
      invalidatesTags: [{ type: 'RMA', id: 'LIST' }],
    },
    findOneRma: {
      providesTags: (result, error, { id }) => [{ type: 'RMA', id }],
    },
    findAllRmasForUser: {
      providesTags: () => [{ type: 'RMA', id: 'LIST' }],
    },
    updateRma: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'RMA', id },
        { type: 'RMA', id: 'LIST' },
      ],
    },
    removeRma: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'RMA', id },
        { type: 'RMA', id: 'LIST' },
      ],
    },
    findAllRepairComments: {
      providesTags: () => [{ type: 'RepairComments', id: 'LIST' }],
    },
    createRepairComment: {
      invalidatesTags: [{ type: 'RepairComments', id: 'LIST' }],
    },
    findOneRepairComment: {
      providesTags: (result, error, { id }) => [{ type: 'RepairComments', id }],
    },
    updateRepairComment: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'RepairComments', id },
        { type: 'RepairComments', id: 'LIST' },
      ],
    },
    removeRepairComment: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'RepairComments', id },
        { type: 'RepairComments', id: 'LIST' },
      ],
    },
    findRepairCommentsByRma: {
      providesTags: () => [{ type: 'RepairComments', id: 'LIST' }],
    },
    findAllInventoryPartsUsed: {
      providesTags: () => [{ type: 'InventoryPartsUsed', id: 'LIST' }],
    },
    createInventoryPartUsed: {
      invalidatesTags: [{ type: 'InventoryPartsUsed', id: 'LIST' }],
    },
    findOneInventoryPartUsed: {
      providesTags: (result, error, { id }) => [
        { type: 'InventoryPartsUsed', id },
      ],
    },
    updateInventoryPartUsed: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'InventoryPartsUsed', id },
        { type: 'InventoryPartsUsed', id: 'LIST' },
      ],
    },
    removeInventoryPartUsed: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'InventoryPartsUsed', id },
        { type: 'InventoryPartsUsed', id: 'LIST' },
      ],
    },
    findAllSignups: {
      providesTags: () => [{ type: 'Signups', id: 'LIST' }],
    },
    createSignup: {
      invalidatesTags: [{ type: 'Signups', id: 'LIST' }],
    },
    findOneSignup: {
      providesTags: (result, error, { id }) => [{ type: 'Signups', id }],
    },
    updateSignup: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Signups', id },
        { type: 'Signups', id: 'LIST' },
      ],
    },
    removeSignup: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Signups', id },
        { type: 'Signups', id: 'LIST' },
        { type: 'Users', id: 'LIST' },
      ],
    },
    findAllUsers: {
      providesTags: () => [{ type: 'Users', id: 'LIST' }],
    },
    createUser: {
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    },
    createUserNoHash: {
      invalidatesTags: [{ type: 'Users', id: 'LIST' }],
    },
    findOneUser: {
      providesTags: (result, error, { id }) => [{ type: 'Users', id }],
    },
    findUserForUser: {
      providesTags: () => [{ type: 'Users', id: 'LIST' }],
    },
    updateUser: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Users', id },
        { type: 'Users', id: 'LIST' },
      ],
    },
    updateForUser: {
      invalidatesTags: (result, error, { updateUserDto }) => [
        { type: 'Users', id: updateUserDto.id },
        { type: 'Users', id: 'LIST' },
      ],
    },
    removeUser: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Users', id },
        { type: 'Users', id: 'LIST' },
      ],
    },
    findAllSoftwareVersions: {
      providesTags: () => [{ type: 'SoftwareVersions', id: 'LIST' }],
    },
    findAllSoftwareVersionsForUser: {
      providesTags: () => [{ type: 'SoftwareVersions', id: 'LIST' }],
    },
    createSoftwareVersion: {
      invalidatesTags: [{ type: 'SoftwareVersions', id: 'LIST' }],
    },
    findOneSoftwareVersion: {
      providesTags: (result, error, { id }) => [
        { type: 'SoftwareVersions', id },
      ],
    },
    updateSoftwareVersion: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'SoftwareVersions', id },
        { type: 'SoftwareVersions', id: 'LIST' },
      ],
    },
    removeSoftwareVersion: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'SoftwareVersions', id },
        { type: 'SoftwareVersions', id: 'LIST' },
      ],
    },
    findAllSoftwareLinks: {
      providesTags: () => [{ type: 'SoftwareLinks', id: 'LIST' }],
    },
    findAllSoftwareLinksForUser: {
      providesTags: () => [{ type: 'SoftwareLinks', id: 'LIST' }],
    },
    createSoftwareLink: {
      invalidatesTags: [{ type: 'SoftwareLinks', id: 'LIST' }],
    },
    findOneSoftwareLink: {
      providesTags: (result, error, { id }) => [{ type: 'SoftwareLinks', id }],
    },
    updateSoftwareLink: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'SoftwareLinks', id },
        { type: 'SoftwareLinks', id: 'LIST' },
      ],
    },
    removeSoftwareLink: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'SoftwareLinks', id },
        { type: 'SoftwareLinks', id: 'LIST' },
      ],
    },
    findAllTypeLinks: {
      providesTags: () => [{ type: 'AnalyzerTypeLinks', id: 'LIST' }],
    },
    findAllTypeLinksForUser: {
      providesTags: () => [{ type: 'AnalyzerTypeLinks', id: 'LIST' }],
    },
    createTypeLink: {
      invalidatesTags: [{ type: 'AnalyzerTypeLinks', id: 'LIST' }],
    },
    findOneTypeLink: {
      providesTags: (result, error, { id }) => [
        { type: 'AnalyzerTypeLinks', id },
      ],
    },
    updateTypeLink: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'AnalyzerTypeLinks', id },
        { type: 'AnalyzerTypeLinks', id: 'LIST' },
      ],
    },
    removeTypeLink: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'AnalyzerTypeLinks', id },
        { type: 'AnalyzerTypeLinks', id: 'LIST' },
      ],
    },
    findAllFirmware: {
      providesTags: () => [{ type: 'Firmware', id: 'LIST' }],
    },
    createFirmware: {
      invalidatesTags: [{ type: 'Firmware', id: 'LIST' }],
    },
    findOneFirmware: {
      providesTags: (result, error, { id }) => [{ type: 'Firmware', id }],
    },
    findAllFirmwareForUser: {
      providesTags: () => [{ type: 'Firmware', id: 'LIST' }],
    },
    updateFirmware: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Firmware', id },
        { type: 'Firmware', id: 'LIST' },
      ],
    },
    removeFirmware: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Firmware', id },
        { type: 'Firmware', id: 'LIST' },
      ],
    },
    findAllUtilities: {
      providesTags: () => [{ type: 'Utilities', id: 'LIST' }],
    },
    createUtility: {
      invalidatesTags: [{ type: 'Utilities', id: 'LIST' }],
    },
    findOneUtility: {
      providesTags: (result, error, { id }) => [{ type: 'Utilities', id }],
    },
    updateUtility: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Utilities', id },
        { type: 'Utilities', id: 'LIST' },
      ],
    },
    removeUtility: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Utilities', id },
        { type: 'Utilities', id: 'LIST' },
      ],
    },
    getAllTypes: {
      providesTags: () => [{ type: 'AnalyzerTypes', id: 'LIST' }],
    },
    createType: {
      invalidatesTags: [{ type: 'AnalyzerTypes', id: 'LIST' }],
    },
    getTypeById: {
      providesTags: (result, error, { id }) => [{ type: 'AnalyzerTypes', id }],
    },
    updateType: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'AnalyzerTypes', id },
        { type: 'AnalyzerTypes', id: 'LIST' },
      ],
    },
    deleteType: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'AnalyzerTypes', id },
        { type: 'AnalyzerTypes', id: 'LIST' },
      ],
    },
    findAllSoftware: {
      providesTags: () => [{ type: 'Software', id: 'LIST' }],
    },
    createSoftware: {
      invalidatesTags: [{ type: 'Software', id: 'LIST' }],
    },
    findOneSoftware: {
      providesTags: (result, error, { id }) => [{ type: 'Software', id }],
    },
    updateSoftware: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Software', id },
        { type: 'Software', id: 'LIST' },
      ],
    },
    removeSoftware: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Software', id },
        { type: 'Software', id: 'LIST' },
      ],
    },
    findAllOperatingSystems: {
      providesTags: () => [{ type: 'OperatingSystem', id: 'LIST' }],
    },
    createOperatingSystem: {
      invalidatesTags: [{ type: 'OperatingSystem', id: 'LIST' }],
    },
    findOneOperatingSystem: {
      providesTags: (result, error, { id }) => [
        { type: 'OperatingSystem', id },
      ],
    },
    updateOperatingSystem: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'OperatingSystem', id },
        { type: 'OperatingSystem', id: 'LIST' },
      ],
    },
    removeOperatingSystem: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'OperatingSystem', id },
        { type: 'OperatingSystem', id: 'LIST' },
      ],
    },
    findAllSupportPurchases: {
      providesTags: () => [{ type: 'SupportPurchase', id: 'LIST' }],
    },
    createSupportPurchase: {
      invalidatesTags: [{ type: 'SupportPurchase', id: 'LIST' }],
    },
    findOneSupportPurchase: {
      providesTags: (result, error, { id }) => [
        { type: 'SupportPurchase', id },
      ],
    },
    updateSupportPurchase: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'SupportPurchase', id },
        { type: 'SupportPurchase', id: 'LIST' },
      ],
    },
    removeSupportPurchase: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'SupportPurchase', id },
        { type: 'SupportPurchase', id: 'LIST' },
      ],
    },
    findAllOrders: {
      providesTags: () => [{ type: 'Orders', id: 'LIST' }],
    },
    createOrder: {
      invalidatesTags: [{ type: 'Orders', id: 'LIST' }],
    },
    findOneOrder: {
      providesTags: (result, error, { id }) => [{ type: 'Orders', id }],
    },
    updateOrder: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Orders', id },
        { type: 'Orders', id: 'LIST' },
      ],
    },
    removeOrder: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Orders', id },
        { type: 'Orders', id: 'LIST' },
      ],
    },
    findAllLicenses: {
      providesTags: () => [{ type: 'Licenses', id: 'LIST' }],
    },
    findLicensesForUser: {
      providesTags: () => [{ type: 'Licenses', id: 'LIST' }],
    },
    createLicense: {
      invalidatesTags: [
        { type: 'Licenses', id: 'LIST' },
        { type: 'Hardware', id: 'LIST' },
      ],
    },
    findOneLicense: {
      providesTags: (result, error, { id }) => [{ type: 'Licenses', id }],
    },
    updateLicense: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Licenses', id },
        { type: 'Licenses', id: 'LIST' },
        { type: 'Hardware', id: 'LIST' },
      ],
    },
    removeLicense: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Licenses', id },
        { type: 'Licenses', id: 'LIST' },
      ],
    },
    findAllLicensesByCompanyId: {
      providesTags: () => [{ type: 'Licenses', id: 'LIST' }],
    },
    findAllSystemModuleLicenses: {
      providesTags: () => [{ type: 'SystemModuleLicenses', id: 'LIST' }],
    },
    findSystemModuleLicensesForUser: {
      providesTags: () => [{ type: 'SystemModuleLicenses', id: 'LIST' }],
    },
    createSystemModuleLicense: {
      invalidatesTags: [{ type: 'SystemModuleLicenses', id: 'LIST' }],
    },
    findOneSystemModuleLicense: {
      providesTags: (result, error, { id }) => [
        { type: 'SystemModuleLicenses', id },
      ],
    },
    updateSystemModuleLicense: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'SystemModuleLicenses', id },
        { type: 'SystemModuleLicenses', id: 'LIST' },
      ],
    },
    removeSystemModuleLicense: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'SystemModuleLicenses', id },
        { type: 'SystemModuleLicenses', id: 'LIST' },
      ],
    },
    findAllSystemModuleLicensesByCompanyId: {
      providesTags: () => [{ type: 'SystemModuleLicenses', id: 'LIST' }],
    },
    findAllModules: {
      providesTags: () => [{ type: 'Modules', id: 'LIST' }],
    },
    createModule: {
      invalidatesTags: [{ type: 'Modules', id: 'LIST' }],
    },
    findOneModule: {
      providesTags: (result, error, { id }) => [{ type: 'Modules', id }],
    },
    updateModule: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Modules', id },
        { type: 'Modules', id: 'LIST' },
      ],
    },
    removeModule: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'Modules', id },
        { type: 'Modules', id: 'LIST' },
      ],
    },
    findAllHardwareCategories: {
      providesTags: () => [{ type: 'HardwareCategories', id: 'LIST' }],
    },
    createHardwareCategory: {
      invalidatesTags: [{ type: 'HardwareCategories', id: 'LIST' }],
    },
    findOneHardwareCategory: {
      providesTags: (result, error, { id }) => [
        { type: 'HardwareCategories', id },
      ],
    },
    updateHardwareCategory: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'HardwareCategories', id },
        { type: 'HardwareCategories', id: 'LIST' },
      ],
    },
    removeHardwareCategory: {
      invalidatesTags: (result, error, { id }) => [
        { type: 'HardwareCategories', id },
        { type: 'HardwareCategories', id: 'LIST' },
      ],
    },
  },
});

export const {
  useGetHelloQuery,
  useLoginMutation,
  useLogoutMutation,
  useRefreshMutation,
  useCreateUserMutation,
  useFindAllUsersQuery,
  useCreateUserNoHashMutation,
  useFindUserForUserQuery,
  useUpdateForUserMutation,
  useFindAllUsersForUserQuery,
  useFindOneUserQuery,
  useUpdateUserMutation,
  useRemoveUserMutation,
  useUpdateEmailPasswordForUserMutation,
  useFindAllCompaniesQuery,
  useCreateCompanyMutation,
  useFindOneCompanyQuery,
  useUpdateCompanyMutation,
  useDeleteCompanyMutation,
  useCreateDemoMutation,
  useFindAllDemosQuery,
  useFindAllDemosForUserQuery,
  useFindOneDemosQuery,
  useUpdateDemoMutation,
  useRemoveDemoMutation,
  useCreateSoftwareMutation,
  useFindAllSoftwareQuery,
  useFindMostRecentVersionNameQuery,
  useFindOneSoftwareQuery,
  useUpdateSoftwareMutation,
  useRemoveSoftwareMutation,
  useCreateSoftwareVersionMutation,
  useFindAllSoftwareVersionsQuery,
  useFindAllSoftwareVersionsForUserQuery,
  useFindOneSoftwareVersionQuery,
  useUpdateSoftwareVersionMutation,
  useRemoveSoftwareVersionMutation,
  useFindLatestSoftwareVersionQuery,
  useSendReleaseEmailMutation,
  useCreateOperatingSystemMutation,
  useFindAllOperatingSystemsQuery,
  useFindOneOperatingSystemQuery,
  useUpdateOperatingSystemMutation,
  useRemoveOperatingSystemMutation,
  useCreateLicenseMutation,
  useFindAllLicensesQuery,
  useFindAllLicensesByCompanyIdQuery,
  useFindLicensesForUserQuery,
  useFindOneLicenseQuery,
  useUpdateLicenseMutation,
  useRemoveLicenseMutation,
  useParseLicensesMutation,
  useCreateHardwareMutation,
  useFindAllHardwareQuery,
  useFindAllHardwareForUserQuery,
  useFindAllDepartmentsForUserQuery,
  useFindOneHardwareQuery,
  useUpdateHardwareMutation,
  useRemoveHardwareMutation,
  useCreateTypeMutation,
  useGetAllTypesQuery,
  useGetTypeByIdQuery,
  useDeleteTypeMutation,
  useUpdateTypeMutation,
  useCreateHardwareCategoryMutation,
  useFindAllHardwareCategoriesQuery,
  useFindOneHardwareCategoryQuery,
  useUpdateHardwareCategoryMutation,
  useRemoveHardwareCategoryMutation,
  useCreateModuleMutation,
  useFindAllModulesQuery,
  useFindOneModuleQuery,
  useUpdateModuleMutation,
  useRemoveModuleMutation,
  useCreateOrderMutation,
  useFindAllOrdersQuery,
  useFindOrdersForUserQuery,
  useFindOneOrderQuery,
  useUpdateOrderMutation,
  useRemoveOrderMutation,
  useDownloadQuoteQuery,
  useDownloadPoQuery,
  useUploadPurchaseOrderMutation,
  useUploadQuoteMutation,
  useCreateInventoryHardwareMutation,
  useFindAllInventoryHardwareQuery,
  useFindOneInventoryHardwareQuery,
  useUpdateInventoryHardwareMutation,
  useRemoveInventoryHardwareMutation,
  useCreateFirmwareMutation,
  useFindAllFirmwareQuery,
  useFindAllFirmwareForUserQuery,
  useFindOneFirmwareQuery,
  useUpdateFirmwareMutation,
  useRemoveFirmwareMutation,
  useGetFirmwareQuery,
  useCreateTypeLinkMutation,
  useFindAllTypeLinksQuery,
  useFindAllTypeLinksForUserQuery,
  useFindOneTypeLinkQuery,
  useUpdateTypeLinkMutation,
  useRemoveTypeLinkMutation,
  useCreateInventoryPartMutation,
  useFindAllInventoryPartsQuery,
  useFindOneInventoryPartQuery,
  useUpdateInventoryPartMutation,
  useRemoveInventoryPartMutation,
  useCreateInventoryPartUsedMutation,
  useFindAllInventoryPartsUsedQuery,
  useFindOneInventoryPartUsedQuery,
  useUpdateInventoryPartUsedMutation,
  useRemoveInventoryPartUsedMutation,
  useCreateRmaMutation,
  useFindAllRmasQuery,
  useSendRmaEmailMutation,
  useSendDepartmentEmailMutation,
  useFindAllRmasForUserQuery,
  useFindOneRmaQuery,
  useUpdateRmaMutation,
  useRemoveRmaMutation,
  useRequestResetMutation,
  useProcessResetMutation,
  useCreateRepairCommentMutation,
  useFindAllRepairCommentsQuery,
  useFindOneRepairCommentQuery,
  useUpdateRepairCommentMutation,
  useRemoveRepairCommentMutation,
  useFindRepairCommentsByRmaQuery,
  useCreateSignupMutation,
  useFindAllSignupsQuery,
  useFindOneSignupQuery,
  useUpdateSignupMutation,
  useRemoveSignupMutation,
  useCreateSoftwareLinkMutation,
  useFindAllSoftwareLinksQuery,
  useFindAllSoftwareLinksForUserQuery,
  useFindOneSoftwareLinkQuery,
  useUpdateSoftwareLinkMutation,
  useRemoveSoftwareLinkMutation,
  useCreateSupportPurchaseMutation,
  useFindAllSupportPurchasesQuery,
  useFindOneSupportPurchaseQuery,
  useUpdateSupportPurchaseMutation,
  useRemoveSupportPurchaseMutation,
  useCreateUtilityMutation,
  useFindAllUtilitiesQuery,
  useFindOneUtilityQuery,
  useUpdateUtilityMutation,
  useRemoveUtilityMutation,
  useFindAlldepartmentsQuery,
  useCreateDepartmentMutation,
  useFindOneDepartmentQuery,
  useUpdateDepartmentMutation,
  useDeleteDepartmentMutation,
  useCreateSystemModuleLicenseMutation,
  useFindAllSystemModuleLicensesQuery,
  useFindAllSystemModuleLicensesByCompanyIdQuery,
  useFindSystemModuleLicensesForUserQuery,
  useFindOneSystemModuleLicenseQuery,
  useUpdateSystemModuleLicenseMutation,
  useRemoveSystemModuleLicenseMutation,
  useParseSystemModuleLicensesMutation,
} = api;
